import * as constAction from 'root/actionConstants';

export const get = (query, abonados) => ({
  type: constAction.ABONADOS_GET,
  payload: { query, abonados },
  epic: {
    url: 'usuarios/buscarUsuario',
    method: 'GET',
  },
});

export const setState = payload => ({
  type: constAction.ABONADOS_SET_STATE,
  payload: payload,
});

export const setLista = payload => ({
  type: constAction.ABONADOS_SET_LISTA,
  payload: payload,
});

export const clear = value => ({
  type: constAction.ABONADOS_CLEAR,
  payload: value,
});

export const getLastAbono = (id, isUser) => ({
  type: constAction.ABONADOS_GET_LAST_ABONO, // BORRAR
  payload: {
    usuarioId: isUser ? id : undefined,
    abonadoId: !isUser ? id : undefined,
  },
  epic: {
    url: 'abonos/getAll',
    method: 'GET',
  },
});

export const getAbonadosActivos = () => ({
  type: constAction.ABONADOS_GET_ACTIVOS,
  epic: {
    url: 'usuarios/abonadosActivos',
    method: 'GET',
  },
});

export const deleteAbono = abonoId => ({
  type: constAction.ABONADOS_DELETE_ABONO,
  payload: {
    abonoId,
  },
  epic: {
    url: 'abonos/cancelar',
    method: 'POST',
  },
});

export const deleteState = payload => ({
  type: constAction.ABONADOS_DELETE_STATE,
  payload,
});

export const setAbono = (fechaDesde, fechaHasta, uid, isUser) => ({
  type: constAction.ABONADOS_SET_ABONO,
  isUser,
  payload: {
    fechaDesde,
    fechaHasta,
    usuarioId: isUser ? uid : undefined,
    abonadoId: !isUser ? uid : undefined,
  },
  epic: {
    url: 'abonos/crear',
    method: 'POST',
  },
});

export const setinState = payload => ({
  type: constAction.ABONADOS_SET_IN_STATE,
  payload,
});

export const addStateRA = (RA, i, trayectoId, pathEdit) => ({
  type: constAction.ABONADOS_ADDOREDIT_RA,
  payload: { RA, i, trayectoId, pathEdit },
});

export const getById = (usuarioId, isUser) => ({
  type: constAction.ABONADOS_GET_BY_ID,
  payload: {
    [isUser ? 'usuarioId' : 'abonadoId']: usuarioId,
    abonos: true,
    extension: true,
    reservasAutomaticas: true,
  },
  epic: {
    url: isUser ? 'usuarios/getFull' : 'usuariosAbonados/getFull',
    method: 'GET',
  },
});

export const set = (payload, id, isUser, usuarioExtension) => ({
  type: constAction.ABONADOS_SET,
  payload,
  id,
  isUser,
  usuarioExtension,
  epic: {
    url: id == 'new' ? 'usuariosAbonados' : `usuariosAbonados/${id}`,
    method: id == 'new' ? 'POST' : 'PATCH',
  },
});

export const getReservasAutomaticas = (id, isUser) => ({
  type: constAction.ABONADOS_RESERVAS_AUTOMATICAS_GET,
  epic: {
    url: isUser ? 'usuarios/' + id + '/_reservasAutomaticas' : `usuariosAbonados/${id}/_reservasAutomaticas`,
    method: 'GET',
  },
});

export const setReservasAutomaticasState = result => ({
  type: constAction.ABONADOS_RESERVAS_AUTOMATICAS_SET_STATE,
  payload: result,
});

export const setReservasAutomaticas = (reservas_automaticas, id, isUser) => {
  let payload = reservas_automaticas.RAId ? reservas_automaticas : { reservas_automaticas: [reservas_automaticas] };
  if (!reservas_automaticas.RAId) payload[isUser ? 'usuarioId' : 'abonadoId'] = id;
  return {
    type: constAction.ABONADOS_RESERVAS_AUTOMATICAS_SET,
    payload,
    epic: {
      url: reservas_automaticas.RAId ? 'reservasAutomaticas/modificar' : 'reservasAutomaticas/crear',
      method: 'POST',
    },
  };
};

export const setExtension = (id, data = {}, isUser) => ({
  type: constAction.ABONADOS_SET_EXTENSION,
  payload: {
    [isUser ? 'usuarioId' : 'abonadoId']: id,
    ...data,
  },
  epic: {
    url: 'usuariosExtension/modificar',
    method: 'POST',
  },
});

export const delRA = (reservaAutomaticaId, path) => ({
  type: constAction.ABONADOS_DELETE_RA,
  path,
  payload: { reservaAutomaticaId },
  epic: {
    url: 'reservasAutomaticas/eliminar',
    method: 'POST',
  },
});

export const delStateRA = path => ({
  type: constAction.ABONADOS_DELETESTATE_RA,
  payload: path,
});

export const getReservasUsuario = (id, isUser) => ({
  type: constAction.ABONADOS_GET_RESERVAS,
  payload: {
    [isUser ? 'usuarioId' : 'abonadoId']: id,
  },
  epic: {
    url: 'reservas/getList',
    method: 'GET',
  },
});

export const getByDoc = (documento, formName) => ({
  type: constAction.ABONADOS_FIND_BYID,
  formName,
  payload: { documento },
  epic: {
    url: 'usuarios/getUsuarioByDoc',
    method: 'GET',
  },
});

export const deleteAbonado = abonadoId => ({
  type: constAction.ABONADOS_DELETE,
  payload: { abonadoId },
  epic: {
    url: 'usuariosAbonados/eliminar',
    method: 'GET',
  },
});

/**
 * Trae la lista de paradas de un trayecto.
 * @returns {Object}
 */
export const getTrayectosParadas = (trayectoId, reducerName) => ({
  type: constAction.ABONADOS_GET_TRAYECTOS_PARADAS,
  parameters: { reducerName },
  payload: { trayectoId },
  epic: {
    url: 'trayectos/getFull',
    method: 'GET',
  },
});

export const setRutinasParadas = (payload, rutinaId) => ({
  type: constAction.ABONADOS_SET_RUTINAS_PARADAS,
  payload: { rutinaId, data: payload },
});



// WEBPACK FOOTER //
// src/modules/abonados/action.js